<template>
  <div class="container-fluid m-0 p-0">
    <div class="row justify-content-center my-5">
      <div class="col-md-7 text-center">
        <h1 class="text-uppercase text-danger">Unsere Leistungen</h1>
        <h2 class="pt-4">
          Wir bieten weit mehr als nur klassische Werbeversprechen – Wir sind ein
          umfassender Partner für den Innenausbau, der technische Expertise, innovative
          Materiallösungen und kreatives Design vereint.
        </h2>
        <h2 class="py-3">
          Dabei fließen präzise Planung, moderne Konstruktionstechniken und ein tiefes
          Verständnis für raumphysikalische Anforderungen in jedes Projekt ein.
        </h2>
      </div>
    </div>

    <div class="row justify-content-center mb-4" id="l1">
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Montage von leichten Trennwänden</h2>
            <p>
              Hier steht die flexible Raumaufteilung im Vordergrund. Mittels moderner
              Montagesysteme werden leichte Trennwände installiert, die schnell und
              unkompliziert errichtet sowie bei Bedarf wieder entfernt oder verändert
              werden können. Dies ermöglicht eine zukunftssichere Raumgestaltung, die sich
              an veränderte Nutzungsanforderungen anpasst.
            </p>
          </div>

          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen2.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l2"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Design-Decken und Wände</h2>
            <p>
              Diese Leistung geht über die reine Funktionalität hinaus. Es werden nicht
              nur Oberflächen geschaffen, sondern integrierte Systeme realisiert, die
              akustische, thermische und optische Mehrwerte bieten. Mit einer breiten
              Palette an Materialien und Oberflächenstrukturen entstehen individuelle
              Raumkonzepte, die sowohl ästhetisch ansprechend als auch technisch optimiert
              sind.
            </p>
          </div>

          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen3.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l3"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Brandschutzverkleidung</h2>
            <p>
              Der Schutz von Personen und Sachwerten hat höchste Priorität. Spezielle
              Brandschutzsysteme werden so konzipiert und verbaut, dass sie den aktuellen
              gesetzlichen Anforderungen entsprechen. Hier fließen Materialien ein, die im
              Ernstfall nicht nur die Ausbreitung von Feuer verlangsamen, sondern auch
              ausreichend Zeit für Evakuierungen und Rettungsmaßnahmen bieten.
            </p>
          </div>
          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen4.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l4"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Raumgestaltung</h2>
            <p>
              Ein ganzheitlicher Ansatz bei der Raumgestaltung bedeutet, dass
              Funktionalität, Ergonomie und Design von Anfang an miteinander verbunden
              werden. Dies umfasst die detaillierte Planung der Raumaufteilung, Licht- und
              Akustikkonzepte sowie die Auswahl passender Materialien, um eine harmonische
              und zugleich effiziente Umgebung zu schaffen.
            </p>
          </div>
          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen5.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l5"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Dachausbau</h2>
            <p>
              Die Umwandlung von ungenutzten Dachräumen in attraktive Wohn- oder
              Arbeitsbereiche ist eine anspruchsvolle Aufgabe. Hierbei werden nicht nur
              technische Aspekte wie Wärmedämmung, Schallschutz und statische
              Anforderungen berücksichtigt, sondern auch die Integration moderner
              Haustechnik, um den Raum komfortabel und nachhaltig nutzbar zu machen.
            </p>
          </div>

          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen6.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l6"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Fußböden</h2>
            <p>
              Die Verlegung von Fußböden spielt eine zentrale Rolle im Gesamtbild des
              Innenraums. Unterschiedliche Materialien – von klassischen Parketts über
              Laminat bis hin zu modernen Designböden – werden passgenau eingesetzt, um
              den jeweiligen Anforderungen an Funktionalität, Langlebigkeit und Optik
              gerecht zu werden.
            </p>
          </div>
          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen7.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l7"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Badsanierung</h2>
            <p>
              Die Renovierung von Badezimmern geht weit über den Austausch einzelner
              Komponenten hinaus. Ein umfassender Sanierungsprozess beinhaltet die
              Optimierung der Raumaufteilung, den Einbau moderner Sanitäreinrichtungen,
              hochwertige Fliesenarbeiten und oft auch die Integration barrierefreier
              Elemente. Dabei wird nicht nur der optische Aspekt, sondern auch die
              technische Funktionalität – wie effiziente Belüftung und energiesparende
              Heizsysteme – in den Fokus gerückt.
            </p>
          </div>
          <div class="col-md-3 p-2">
            <img
              src="../assets/Leistungen/leistungen8.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l8"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Energiespartüren im Sonderangebot</h2>
            <p>
              Steigern Sie Ihre Energieeffizienz und senken Sie Ihre Heizkosten mit
              modernen Energiespartüren! Dank hochwertiger Wärmedämmung bleibt die Wärme
              im Haus – das schont nicht nur die Umwelt, sondern auch Ihren Geldbeutel.
            </p>
            <p>
              Nutzen Sie staatliche Zuschüsse von 15 - 20%
              <span class="extraklein">( Stand März 2025 )</span> für den Einbau und
              sparen Sie doppelt: durch Förderung und langfristig geringere Energiekosten.
            </p>
            <p>
              Setzen Sie stilvolle Akzente mit LED-beleuchteten Türen! Diese sorgen für
              eine moderne Optik und zusätzliche Orientierung im Dunkeln – ideal für
              Haustüren, Flure oder Eingangsbereiche.
            </p>
          </div>

          <div class="col-md-3 p-2">
            <karussellSwiperEnergie/>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center animated-div mb-4"
      ref="animatedSection"
      id="l8"
    >
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-9 p-5">
            <h2 class="pb-3">Haus- und Wohnungstüren</h2>
            <p>
              Entdecken Sie hochwertige Haus- und Wohnungstüren, die Sicherheit,
              Energieeffizienz und ansprechendes Design vereinen. Ob modern, klassisch
              oder individuell – wir bieten maßgeschneiderte Lösungen, die perfekt zu
              Ihrem Zuhause passen.
            </p>
            <ul>
              <li class="noDekoration">✔ Sicherheit & Einbruchschutz</li>
              <li class="noDekoration">✔ Energieeffiziente Materialien</li>
              <li class="noDekoration">✔ Individuelles Design & Maßanfertigung</li>
              <li class="noDekoration">✔ Fachgerechte Beratung & Montage</li>
            </ul>

            <p>
              Vertrauen Sie auf Qualität vom Fachmann – für ein sicheres und stilvolles
              Zuhause!
            </p>
            <p>
              Wir können Ihnen aus dem reichhaltigen Angebot von Köster Aluminium über 100
              verschiedene Türen in unterschiedlichen Zusammenstellungen und Farben
              anbieten.
            </p>
          </div>

          <div class="col-md-3 p-2">            
           <karussellSwiperHaustueren/>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center animated-div mb-4" ref="animatedSection">
      <div class="col-md-8">
        <div class="row rowschatten">
          <div class="col-md-7 p-5">
            <h2 class="pb-3">Fazit</h2>
            <p>
              Als professionelles Trockenbauunternehmen agieren wir als Schnittstelle
              zwischen Technik und Design. Durch den Einsatz innovativer Materialien und
              moderner Verfahren werden Räume nicht nur gestaltet, sondern nachhaltig
              optimiert – technisch, ästhetisch und funktional. Dies ermöglicht
              individuelle Lösungen, die sowohl den höchsten Sicherheitsstandards als auch
              den gestalterischen Ansprüchen von Privat- und Geschäftskunden gerecht
              werden.
            </p>
          </div>
          <!-- <div class="col-1"></div> -->
          <div class="col-5 p-2">
            <img
              src="../assets/LogoKomplett.jpg"
              alt="ltb-logo"
              class="img-fluid rundeEcken p-3"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center animated-div" ref="animatedSection">
      <div class="col-md-5"><karussell2 /></div>
    </div>
  </div>
  <stickybarTelMail />

  <stickyPfeil />
</template>

<script setup>
import { ref, onMounted } from "vue";

const animatedSection = ref(null); // Einzelne Referenz für das Sammeln

onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  // Manuelles Sammeln aller divs mit der Klasse "animated-div"
  const sections = document.querySelectorAll(".animated-div");

  sections.forEach((el) => {
    observer.observe(el);
  });
});
</script>

<script>
import stickyPfeil from "../components/stickyPfeil.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";

import karussell2 from "../components/karussellSwiper2.vue";
import karussellSwiperEnergie from "../components/karussellSwiperEnergie.vue";
import karussellSwiperHaustueren from "../components/karussellSwiperHaustueren.vue";

export default {
  name: "LeistungenPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    stickyPfeil,
    stickybarTelMail,
    karussell2,
    karussellSwiperEnergie,
    karussellSwiperHaustueren,
  },
  methods: {},
  computed: {},
};
</script>
